module.exports = __webpack_public_path__ + "static/img/uccb.d981327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/uccb.png
// module id = gYRW
// module chunks = 93